import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './fonts.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
